const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("iinspire_token");
export const setToken = (t) => localStorage.setItem("iinspire_token", t);
export const clearToken = () => {
  localStorage.removeItem("iinspire_token");
  localStorage.removeItem("iinspire_user");
};
export const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("iinspire_user") || "null");
  } catch {
    return null;
  }
};
export const setStoredUser = (u) => localStorage.setItem("iinspire_user", JSON.stringify(u));

export const apiFetch = async (path, options = {}) => {
  const headers = { ...(options.headers || {}) };
  if (options.body) headers["Content-Type"] = "application/json";
  const token = getToken();
  if (token) headers["Authorization"] = `Bearer ${token}`;
  const res = await fetch(`${API}${path}`, { ...options, headers });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    const detail = err.detail;
    throw new Error(
      typeof detail === "string"
        ? detail
        : Array.isArray(detail)
          ? detail.map((e) => e?.msg || "").join(" ")
          : "Request failed"
    );
  }
  return res.json();
};

export const waHref = (phone, message = "") => {
  const digits = String(phone || "").replace(/\D/g, "").replace(/^0(?!$)/, "60");
  return `https://wa.me/${digits}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
};

export { API };
